import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActiveSegmentListConfig} from '../../../segment/segment-config.model';
import {CustomConfigurationFacadeService} from '../../custom-configuration-facade.service';

@Component({
  selector: 'app-active-table-custom-configuration',
  template: `
    <app-table-custom-configuration
      [allOptions]="allAvailableTableColumns"
      [defaultOptions]="defaultTableColumns"
      [persistedConfiguration]="persistedConfig$ | async"
      (configChanged)="onConfigChange($event)"
    >
    </app-table-custom-configuration>
  `,
  styleUrls: ['./active-table-custom-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActiveTableCustomConfigurationComponent implements OnInit {
  allAvailableTableColumns = ActiveSegmentListConfig.allAvailableTableColumns;
  defaultTableColumns = ActiveSegmentListConfig.defaultTableColumns;
  persistedConfig$ = this.facade.selectTableColumns();

  constructor(private facade: CustomConfigurationFacadeService) {
  }

  ngOnInit(): void {
    this.facade.load();
  }

  onConfigChange(changedColumns: string[]) {
    this.facade.save({tableColumns: changedColumns});
  }

}
